let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dBEdI")).then(() => parcelRequire('lmcPJ'));